import { observable, action } from 'mobx';
import { setter } from 'mobx-decorators';
import translationsStore from './translationsStore';
import agent from '../services/web/agent';
import oidcStore from './oidcStore';
import CommonValidator from '../services/validations/commonValidators';

class twoFAStore {

    @setter @observable authKey;
    @setter @observable qrCodeUri;
    @setter @observable verificationCode;
    @setter @observable verificationErrorMessage;
    @setter @observable recoveryCodes = [];
    @setter @observable currentStep;
    @setter @observable is2FAEnabled;
    @setter @observable disable2FAErrorMessage;
    @setter @observable recoveryCodesMessage = '';
    @setter @observable authenticatorKeyMessage = '';
    @setter @observable authenticatorKetResetted = false;
    @setter @observable stepInProgress;
    @setter @observable username = window.sessionStorage.getItem('username');
    @setter @observable redirectAfterSetup = false;
    @setter @observable isForgetMeEnabled = false;

    formErrors = [];

    setRedirectAfterSetup(val) {
        this.redirectAfterSetup = val;
    }

   @action setCode(code) {
         this.verificationCode = code;
    }

    @action changeStep(step) {
        this.currentStep = step;
    }

    @action changeStepInProgress(status) {
        this.stepInProgress = status;
    }


    setIsForgetMeEnabled(isEnabled) {
        this.isForgetMeEnabled = isEnabled;
    }

    @observable twoFactorSteps = {
        authoptions: 'authoptions',
        setupauthapp: 'setupauthapp',
        recoverycodes: 'recoverycodes',
        resetcodes: 'resetrecoverycodes',
        disable2fa: 'disabletwofactor',
        resetauthkey:'reserauthenticatorkey'
    }

    @action getAuthenticatorKeyandQRCode() {
        return agent.TwoFactorAuth.getAuthenticatorKeyAndCode()
           .then(action((data) => {
               this.authKey = data.authenticatorKey;
               this.qrCodeUri = data.qrCodeUri;
        }));
    };

    @action setUsername = (username) => {
        this.username = username;
        window.sessionStorage.setItem('username', username);
    }

    @action forgetBrowser() {
        return agent.TwoFactorAuth.forgetMe()
            .catch(action((err) => {
                this.changeStepInProgress(false);
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action isClientRemembered() {
        return agent.TwoFactorAuth.isClientRemembered()
            .catch(action((err) => {
                this.changeStepInProgress(false);
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action resetAuthenticatorKey() {
        return agent.TwoFactorAuth.resetAuthenticatorKey()
            .catch(action((err) => {
                this.changeStepInProgress(false);
                 if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));

    }

    @action enableTwoFactorAuth() {
        return agent.TwoFactorAuth.enableTwoFactorAuth(this.verificationCode, this.username)
           .catch(action((err) => {
                this.changeStepInProgress(false);
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action disableTwoFactorAuth() {
        return agent.TwoFactorAuth.disableTwoFactorAuth()
            .catch(action((err) => {
                this.changeStepInProgress(false);
                if (err && err.response && err.response.text) {
                    this.disable2FAErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action getRecoveryCodes() {
    
        return agent.TwoFactorAuth.getRecoveryCodes()
            .catch(action((err) => {
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action resetTwoFactorAuth() {
        return agent.TwoFactorAuth.resetTwoFactorAuth()
            .catch(action((err) => {
                this.changeStepInProgress(false);
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action getTwoFactorStatus() {
        return agent.TwoFactorAuth.getTwoFactorStatus()
            .catch(action((err) => {
                if (err && err.response && err.response.text) {
                    this.verificationErrorMessage = JSON.parse(err.response.text).Message;
                }
                this.errors = err.response && err.response.body && err.response.body.errors;
                throw err;
            }));
    };

    @action validateTwoFactorToken() {
        const validation = CommonValidator.validateGenericRequiredFieldWithConcreteName('Two-Factor Token', this.verificationCode);
        this.verificationErrorMessage = validation.errors.first('Two-Factor Token');
        this.formErrors.push(validation.errorCount);
    };

    @action validateTwoFactorSetupForm() {
        this.formErrors = [];
        this.validateTwoFactorToken();
        if (this.formErrors.filter((valid) => valid > 0).length > 0) {
            return false;
        }

        return true;
    };
}
export default new twoFAStore();